module.exports = __webpack_public_path__ + "static/media/west berlin.5576e20b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/west berlin.jpg
// module id = 473
// module chunks = 0